import {useState} from "react";
import {useDispatch} from "react-redux";
import {changePrimaryColor, changeTheme} from "../../redux/actions/themeActions";

const useController = () => {
    const dispatch = useDispatch();

    const [collapsed, setCollapsed] = useState(true);

    return {
        collapsed,
        setCollapsed: () => setCollapsed(!collapsed),
        changeTheme: theme => dispatch(changeTheme(theme)),
        changePrimaryColor: primaryColor => dispatch(changePrimaryColor(primaryColor))
    }
};

export default useController;